class exports.StepFunctions

    # The StepFunctions class is basically a wrapper around the generic step
    # functions.

    # Each of these functions should be passed a StepHandler object, and
    # should return true, unless it is desirable to stop the StepTransition.
    # In the case of skipXXX() functions, the return value indicates whether
    # we should skip the step it is being applied to or not.
    # Note that within these functions, 'this' is defined in the context of the
    # StepHandler object, not the StepFunctions object.

    testFunc: () ->
        step = this
        #alert 'checking checked checkboxes'
        return true


    addExpectedYieldValidation: () ->
        step = this

        # yield goal must be between 0 and 500
        step.getInputEl().addClass('validate-in-range').attr('data-min', 0).attr('data-max', 500)

        return true


    addMaturityValidation: () ->
        step = this

        step.getInputEl().addClass('validate-in-range').attr('data-min', 70).attr('data-max', 120)

        # add some fancy logic to make sure the max is greater than the min
        minMaturityID = step.taffyObjects.y_aspects( display_name: 'Min Maturity' ).first().aspects_id
        maxMaturityID = step.taffyObjects.y_aspects( display_name: 'Max Maturity' ).first().aspects_id
        minMaturity = step.getInputEl( aspect: minMaturityID )
        maxMaturity = step.getInputEl( aspect: maxMaturityID )

        minMaturity.on 'change', () ->
            el = $(this)
            # run this after the validation, which uses .delegate
            setTimeout () ->
                valid = not el.is '[class*="mfvalidate-invalid"]'
                maxMaturity.attr 'data-min', if valid then el.val() else 70
            , 0

        maxMaturity.on 'change', () ->
            el = $(this)
            # run this after the validation, which uses .delegate
            setTimeout () ->
                valid = not el.is '[class*="mfvalidate-invalid"]'
                minMaturity.attr 'data-max', if valid then el.val() else 120
            , 0


        return true


    addSoybeanMaturityValidation: () ->
        step = this

        # add some fancy logic to make sure the max is greater than the min
        # basically just don't allow max < min or min > max
        minMaturityID = step.taffyObjects.y_aspects( aspect_name: 'Min Maturity' ).first().aspects_id
        maxMaturityID = step.taffyObjects.y_aspects( aspect_name: 'Max Maturity' ).first().aspects_id
        minMaturity = step.getInputEl( aspect: minMaturityID )
        maxMaturity = step.getInputEl( aspect: maxMaturityID )

        minMaturity.on 'change', () ->
            minID = minMaturity.val()
            maxID = maxMaturity.val()

            if minID
                if not maxID
                    maxMaturity.val(minID).trigger('change')
                else
                    # look up the numeric values to compare
                    min = step.taffyObjects.query_options( id: parseInt(minID) ).first()
                    max = step.taffyObjects.query_options( id: parseInt(maxID) ).first()

                    if max.numeric_value < min.numeric_value
                        maxMaturity.val(minID).trigger('change')

        maxMaturity.on 'change', () ->
            minID = minMaturity.val()
            maxID = maxMaturity.val()

            if maxID
                if not minID
                    minMaturity.val(maxID).trigger('change')
                else
                    # look up the numeric values to compare
                    min = step.taffyObjects.query_options( id: parseInt(minID) ).first()
                    max = step.taffyObjects.query_options( id: parseInt(maxID) ).first()

                    if min.numeric_value > max.numeric_value
                        minMaturity.val(maxID).trigger('change')

        return true


    skipIfNoRootworm: () ->
        step = this
        arbitraryFieldID = step.parent.taffyObjects.fields(selected: true).first().id
        return not step.parent.getFieldAspectByName(arbitraryFieldID, 'Rootworm').value


    skipIfAllIntegratedRefuge: () ->
        step = this

        all_integrated_refuge = true
        selected_fields = step.parent.taffyObjects.fields( selected: true )
        selected_fields.each (field, i) ->
            # check whether the selected Refuge Mangagement option is Blended
            if step.parent.getFieldAspectByName(field.id, 'Refuge-in-Bag').option_name isnt 'Blended'
                all_integrated_refuge = false
                return false

        return all_integrated_refuge

    # error: (msg, obj=null) =>
    #     debugLog 'Failed to create Step_Options object. '+msg
    #     debugLog obj if obj?
    #     return null
